'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _grid = require('../grid');

exports['default'] = _grid.Row;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/row/index.js
// module id = 664
// module chunks = 0